<dgl-notifier></dgl-notifier>
<dgl-dialog></dgl-dialog>
<dgl-global-spinner></dgl-global-spinner>
<!-- TODO: create main app html structure -->
<!--<dgl-filters></dgl-filters>-->
<router-outlet></router-outlet>
